// extracted by mini-css-extract-plugin
export default {"container":"FilterDropdown_container__Im5bx","filtersGrid":"FilterDropdown_filtersGrid__zo7Qz","footer":"FilterDropdown_footer__mfkep"};